import { useInfiniteQuery } from '@tanstack/react-query';

import { useErrorMessage } from '#error-message/useErrorMessage';

import { GroupService } from './groupService';
import { GroupKey } from './keys';

export function useGetGroupsInfinite(name: string, enabled = true) {
  const getGroupsInfiniteQuery = useInfiniteQuery({
    queryKey: [GroupKey.GROUPS_INFINITE, name],
    queryFn: ({ pageParam }) => GroupService.getGroups({ ...pageParam, name }).then((response) => response.data),
    initialPageParam: { page: 0, pageSize: 20, name: undefined },
    getNextPageParam: (lastPage, allPages, lastPageParam) => {
      if (lastPage.length < lastPageParam.pageSize) {
        return undefined;
      }
      return { ...lastPageParam, page: lastPageParam.page + 1 };
    },
    enabled: enabled,
  });

  const errorMessage = useErrorMessage(getGroupsInfiniteQuery.error);

  return {
    ...getGroupsInfiniteQuery,
    errorMessage,
  };
}
